













































import Proxyable from '@/mixins/proxyable';
import mixins from '@/utils/mixins';

import { getCurrencySymbol } from '@/utils/currency';
import { mask } from '@/utils/helpers';

export default mixins(Proxyable).extend({
  name: 'QuoteDiscountTextField',

  props: {
    total: { type: Number, required: true },
    exchangeRate: Number,
    currencyCode: String
  },

  data: () => ({
    displayDiscountAsDollarAmount: false,
    focus: {
      discountAsPercent: false
    },
    discountAsPercent_: '0'
  }),

  computed: {
    discountAsPercent: {
      get() {
        return mask(this.discountAsPercent_, 3, this.focus.discountAsPercent);
      },
      set(value: string) {
        this.discountAsPercent_ = value;
      }
    },

    totalWithExchangeRateApplied(): number {
      return this.total * this.exchangeRate;
    },

    percentageRules() {
      return [
        (v: number) => v <= 100 || 'Cannot be greater than 100%',
        (v: number) => v >= 0 || 'Cannot be less than 0%'
      ];
    },
    discountRules() {
      return [
        (v: number) =>
          Number(v) <= this.totalWithExchangeRateApplied ||
          'Cannot be greater than total'
      ];
    }
  },

  watch: {
    internalValue: {
      handler() {
        this.discountAsPercent = this.calculateDiscountPercent().toString();
      }
    }
  },

  mounted() {
    this.discountAsPercent = this.calculateDiscountPercent().toString();
  },

  methods: {
    getCurrencySymbol,

    calculateDiscountPercent(): number {
      if (this.total <= 0) return 0;
      return (Number(this.internalValue) / this.total) * 100;
    },

    calculateDiscountAmount(percentage: number): number {
      return (percentage / 100.0) * this.total;
    },

    onSwitchChangeHandler(showAsDollarAmount: boolean) {
      if (!showAsDollarAmount) {
        this.discountAsPercent = this.calculateDiscountPercent().toString();
      }
    },

    discountPercentageInputHandler(percentage: string) {
      const discountForm = this.$refs.discountForm as any;
      if (discountForm.validate()) {
        this.internalValue = this.calculateDiscountAmount(Number(percentage));
      }
    },

    discountAmountInputHander(discount: string) {
      const discountForm = this.$refs.discountForm as any;
      if (discountForm.validate()) {
        this.internalValue = discount;
      }
    }
  }
});
